import React from 'react';
import { RestrictedComponent } from '../../ui-components/RestrictedComponent';
import { Profile } from './Profile';

export const ProfilePageWrapper = () => (
  <RestrictedComponent permission='edit_user_data'>
    <Profile />
  </RestrictedComponent>
);
